import React from 'react';
import { getRevealVisual } from './visuals';

const ModuleRevealVisual = ({ tone, revealMeta }) => {
  const Visual = getRevealVisual(tone);
  return <Visual revealMeta={revealMeta} />;
};

export default ModuleRevealVisual;
